export const authorizationSelector = (state: any) => {
  const { api: { permissionsByOperationId }, auth: { permissions } } = state
  return {
    permissions,
    permissionsByOperationId
  }
}
